import interceptor from '@/plugins/interceptor';
const pathController = '/Certify'

export default {
  state: () => ({
  }),
  getters: {
  },
  mutations: { 
  },
  actions: {
    async certify_certify({ dispatch }, model) {
      try {
        const response = await interceptor.authenticate.postFileBlob(`${process.env.VUE_APP_API_URL}${pathController}/certify`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.create'), title: window.vueApp.$t('left_menu.spot_programming.certificate')});
        return response;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.certificate'), error: true});
        throw new Error(error);
      }
    }
  }
}

